<template>
  <div class="wrapper_contacts">
    <router-link :to="{ name: 'Login' }"
      ><img class="contactImg" v-if="companiesConfig.logo" :src="companiesConfig.logo.svg"
    /></router-link>
    <keep-alive>
      <div class="box">
        <transition name="component-fade" mode="out-in">
          <div class="content" v-if="pageName === 'Login' && login" :key="login">
            <h6>
              {{ localStorage.translations.pages.auth.titles.vhod }}
            </h6>
            <v-form ref="form" v-model="valid" @submit.prevent="onLogin" lazy-validation>
              <div class="container_form">
                <label>{{
                  localStorage.translations.pages.auth.labels['elektronnaya-pochta']
                }}</label>
                <v-text-field
                  height="48px"
                  :rules="
                    !loginError
                      ? [inputRules.required, inputRules.email]
                      : [loginErrorMessage, inputRules.email]
                  "
                  v-model="email"
                ></v-text-field>
                <label>{{ localStorage.translations.pages.auth.labels['parol'] }}</label>
                <v-text-field
                  height="48px"
                  :rules="
                    !loginError
                      ? [inputRules.required, inputRules.min6]
                      : [loginErrorMessage, inputRules.min6]
                  "
                  type="password"
                  v-model="password"
                ></v-text-field>
                <div class="flex">
                  <v-checkbox
                    v-model="checkbox"
                    :label="localStorage.translations.pages.common.checkbox['remember_me']"
                    class="checkbox"
                  ></v-checkbox>
                  <span @click="login = false" class="how_password f16"
                    >{{ localStorage.translations.pages.auth.buttons['zabyli-parol'] }}?</span
                  >
                </div>
                <BaseButton
                  type="submit"
                  :text="localStorage.translations.pages.auth.buttons['voyti']"
                />
              </div>
            </v-form>
          </div>
          <div
            class="content"
            v-else-if="pageName === 'Login' && !login && !changePass"
            :key="changePass"
          >
            <h6>
              {{ localStorage.translations.pages.auth.titles['vosstanovlenie-parolya'] }}
            </h6>
            <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="onChangePass">
              <div class="container_form">
                <label>{{
                  localStorage.translations.pages.auth.labels['elektronnaya-pochta']
                }}</label>
                <v-text-field
                  height="48px"
                  :rules="
                    !changePassError
                      ? [inputRules.required, inputRules.email]
                      : [emailRules, inputRules.email]
                  "
                  v-model="email"
                ></v-text-field>
                <div class="flex reset">
                  <BaseButton
                    type="submit"
                    :text="localStorage.translations.pages.auth.buttons['otpravit']"
                  />
                  <BaseButton
                    reverse
                    @click="login = true"
                    :text="localStorage.translations.pages.auth.buttons['otmena']"
                  />
                </div>
              </div>
            </v-form>
          </div>
          <div
            class="content"
            v-else-if="pageName === 'Login' && !login && changePass"
            :key="confirm"
          >
            <div class="confirm">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 0C6.71571 0 0 6.71571 0 15C0 23.2843 6.71571 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71571 23.2843 0 15 0ZM15 2.90323C21.6854 2.90323 27.0968 8.31357 27.0968 15C27.0968 21.6854 21.6864 27.0968 15 27.0968C8.3146 27.0968 2.90323 21.6864 2.90323 15C2.90323 8.3146 8.31357 2.90323 15 2.90323ZM23.4801 10.7823L22.117 9.40821C21.8347 9.12363 21.3752 9.12175 21.0906 9.40409L12.5411 17.8849L8.92464 14.2391C8.64236 13.9545 8.1828 13.9527 7.89823 14.2349L6.52409 15.598C6.23952 15.8803 6.23764 16.3398 6.51998 16.6245L12.0108 22.1597C12.293 22.4443 12.7526 22.4462 13.0372 22.1638L23.476 11.8088C23.7605 11.5264 23.7624 11.0669 23.4801 10.7823Z"
                  fill="#26BC2C"
                />
              </svg>
              <p>
                {{
                  localStorage.translations.pages.common.notifications[
                    'password_recovery_link_send'
                  ]
                }}
              </p>
            </div>
          </div>
          <div class="content" v-else-if="pageName === 'ConfirmEmail'">
            <h6>
              {{ localStorage.translations.pages.auth.titles['sozdanie-parolya'] }}
            </h6>
            <v-form
              ref="form"
              class="container_form"
              lazy-validation
              v-model="valid"
              @submit.prevent="registerConfirm"
              autocomplete="off"
            >
              <BaseInput
                v-model="email"
                :label="localStorage.translations.pages.auth.labels['podtverdite-pochtu']"
                :hideDetails="false"
                :rules="['required', 'email']"
                autocomplete="new-password"
                input-type="text"
                :input-name="Math.random()"
              />
              <BaseInput
                v-model="password"
                :label="localStorage.translations.pages.auth.labels['pridumayte-parol']"
                :hideDetails="false"
                :rules="['required', 'min6']"
                input-type="password"
                :input-name="Math.random()"
                autocomplete="new-password"
                @click:append="show = !show"
              />
              <BaseInput
                v-model="password_confirmation"
                :label="localStorage.translations.pages.auth.labels['povtorite-parol']"
                :hideDetails="false"
                :rules="['required', passwordConfirmationRule]"
                input-type="password"
                :input-name="Math.random()"
                autocomplete="new-password"
                @click:append="show1 = !show1"
              />
              <BaseButton
                type="submit"
                :text="localStorage.translations.pages.auth.buttons['sozdat-parol']"
              />
            </v-form>
          </div>
          <div class="content" v-else-if="pageName === 'ConfirmRestore'">
            <h6>
              {{ localStorage.translations.pages.auth.titles['vosstanovlenie-parolya'] }}
            </h6>
            <v-form
              ref="form"
              class="container_form"
              lazy-validation
              v-model="valid"
              @submit.prevent="restoreConfirm"
              autocomplete="off"
            >
              <label>{{
                localStorage.translations.pages.auth.labels['elektronnaya-pochta']
              }}</label>
              <v-text-field
                outlined
                height="48px"
                v-model="email"
                :rules="[inputRules.required, inputRules.email]"
              ></v-text-field>
              <label>{{ localStorage.translations.pages.auth.labels['pridumayte-parol'] }}</label>
              <v-text-field
                :style="{ display: 'none' }"
                outlined
                height="48px"
                v-model="passwordfake"
                type="password"
                :name="Math.random()"
              ></v-text-field>
              <v-text-field
                outlined
                height="48px"
                v-model="password"
                :rules="[inputRules.required, inputRules.min6]"
                type="password"
                name="Math.random()"
                @click:append="show = !show"
              ></v-text-field>
              <label>{{ localStorage.translations.pages.auth.labels['povtorite-parol'] }}</label>
              <v-text-field
                outlined
                height="48px"
                v-model="password_confirmation"
                :rules="[inputRules.required, passwordConfirmationRule]"
                type="password"
                name="input-10-1"
                @click:append="show1 = !show1"
              ></v-text-field>
              <BaseButton
                type="submit"
                :text="localStorage.translations.pages.auth.buttons['sozdat-parol']"
              />
            </v-form>
          </div>
          <div class="content" v-else-if="pageName === 'FirstAuth'">
            <h6>
              {{ localStorage.translations.pages.auth.titles['personalnye-dannye'] }}
            </h6>
            <v-form
              ref="form"
              class="container_form"
              lazy-validation
              v-model="valid"
              @submit.prevent="updateUser"
            >
              <label>{{
                localStorage.translations.pages.auth.labels['elektronnaya-pochta']
              }}</label>
              <v-text-field
                outlined
                height="48px"
                v-model="email"
                :rules="[inputRules.required, inputRules.email]"
                disabled
              ></v-text-field>
              <label>{{ localStorage.translations.pages.auth.labels['imya'] }}</label>
              <v-text-field
                outlined
                height="48px"
                v-model="first_name"
                :rules="[inputRules.required]"
              ></v-text-field>
              <label>{{ localStorage.translations.pages.auth.labels['familiya'] }}</label>
              <v-text-field
                outlined
                height="48px"
                v-model="last_name"
                :rules="[inputRules.required]"
              ></v-text-field>
              <label>{{ localStorage.translations.pages.auth.labels['nomer-telefona'] }}</label>
              <vue-tel-input-vuetify
                outlined
                v-model="phone[0]"
                label=""
                :rules="[inputRules.required, rules.phoneCountry]"
                placeholder=""
                @input="onInput"
                disabledFetchingCountry
                defaultCountry="FI"
              ></vue-tel-input-vuetify>
              <BaseButton
                type="submit"
                :text="localStorage.translations.pages.common.buttons['sohranit']"
              />
            </v-form>
          </div>
        </transition>
      </div>
    </keep-alive>
    <contacts-footer></contacts-footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContactsFooter from 'components/icons/ContactsFooter'

export default {
  name: 'Auth',
  components: { ContactsFooter },
  data() {
    return {
      valid: false,
      checkbox: false,
      login: true,
      changePass: false,
      changePassError: false,
      email: '',
      password: '',
      password_confirmation: '',
      passwordfake: '',
      first_name: '',
      last_name: '',
      phone: [],
      numberInternational: null,
      phoneInput: {
        number: '',
        valid: false,
        country: undefined,
      },
      emailRules: (v) => /.+@.+\..+/.test(v) || '',
      loginError: false,
      loginErrorMessage: (v) => !!v || '',
    }
  },
  created() {
    this.onActualUserData()
  },
  watch: {
    userData() {
      this.onActualUserData()
    },
    numberInternational() {
      if (this.phone[0].length > 4) {
        this.phone[0] = this.numberInternational
      }
    },
    pageName() {
      this.onActualUserData()
    },
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters(['companiesConfig']),
    userData() {
      return this.$store.getters['user/userData']
    },
    passwordConfirmationRule() {
      return (v) =>
        v == this.password || this.localStorage.translations.pages.common.rules['password_mismatch']
    },
    pageName() {
      return this.$route.name
    },
    rules() {
      return {
        phoneCountry: (v) =>
          this.phoneInput.valid ||
          this.localStorage.translations.pages.common.rules['phone_country'],
      }
    },
  },
  methods: {
    ...mapActions('userInterface', ['onUserInterfacePage']),
    ...mapActions(['onCompaniesConfig']),
    validate() {
      this.$refs.form.validate()
    },
    onActualUserData() {
      if (this.userData && this.pageName == 'FirstAuth') {
        this.email = this.userData.email
        this.first_name = this.userData.first_name
        this.last_name = this.userData.last_name
        if (this.userData.phone) {
          this.phone = this.userData.phone
        }
      }
    },
    onInput(formattedNumber, { number, valid, country }) {
      this.numberInternational = number.international
      this.phoneInput.valid = valid
      this.phoneInput.country = country && country.name
    },
    async onLogin() {
      await this.validate()
      if (this.valid === true) {
        let data = {
          language_id: this.localStorage.translations.language_id,
          username: this.email,
          password: this.password,
          client_id: 1,
          client_secret: 'kAUsFYysaEEi82JrFgzgYcU8SJzx8ubRkf7NJj8l',
          grant_type: 'password',
        }

        this.$store
          .dispatch('auth/AUTH_login', {
            save: this.pageName == 'Login' ? this.checkbox : true,
            data,
          })
          .then(() => {
            if (this.pageName == 'Login') {
            }
            // else if (this.pageName == 'ConfirmEmail') {
            //     this.$router.push({ name: 'FirstAuth' })
            // }
            else if (this.pageName == 'ConfirmRestore') {
              this.$router.push({ name: 'PersonalArea' })
            }
            this.onCompaniesConfig()
          })
          .catch((err) => {
            if (this.pageName == 'Login') {
              this.loginError = true
              this.email = ''
              this.password = ''
              this.loginErrorMessage = [(v) => !!v || err.response.data.message]
            } else {
              this.$router.push({ name: 'Login' })
            }
          })
      } else return
    },
    async onChangePass() {
      await this.validate()
      if (this.valid === true) {
        let data = {
          email: this.email,
          language_id: this.localStorage.translations.language_id,
        }
        this.$store
          .dispatch('auth/passwordChange', data)
          .then(() => (this.changePass = true))
          .catch((err) => {
            this.email = ''
            this.changePassError = true
            if (err.response.data.errors) {
              this.emailRules = (v) => !!v || err.response.data.errors.email[0]
            } else {
              this.emailRules = (v) => !!v || err.response.data
            }
          })
      } else return
    },

    async registerConfirm() {
      await this.validate()
      if (this.valid === true) {
        let data = {
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          language_id: this.localStorage.translations.language_id,
          token: this.$attrs.token,
        }
        this.$store
          .dispatch('auth/registerConfirm', data)
          .then((response) => {
            if (response) {
              this.onLogin()
            }
          })
          .catch(() => {
            this.email = ''
            this.password = ''
            this.password_confirmation = ''
          })
      }
    },
    async restoreConfirm() {
      await this.validate()
      if (this.valid === true) {
        let data = {
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          language_id: this.localStorage.translations.language_id,
          token: this.$attrs.token,
        }
        this.$store
          .dispatch('auth/passwordChangeConfirm', data)
          .then((response) => {
            if (response) {
              this.onLogin()
            }
          })
          .catch(() => {
            this.email = ''
            this.password = ''
            this.password_confirmation = ''
          })
      }
    },
    async updateUser() {
      await this.validate()
      if (this.valid) {
        let data = {
          // id: this.userData.id,
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.phone,
        }

        this.$store
          .dispatch('user/updateUser', data)
          .then((response) => {
            if (response) {
              this.$router.push({ name: 'PersonalArea' })
            }
          })
          .catch
          // err => console.log(err),
          ()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  &.reset {
    margin-top: 16px;
    justify-content: flex-start;
    display: grid;
    grid-template-columns: max-content max-content;
    column-gap: 30px;
  }
}
</style>

<style>
.wrapper_contacts .v-text-field .v-input__slot {
  margin-bottom: 0px !important;
  padding-left: 16px;
  padding-right: 16px;
  border: 1px solid #b4b4b4;
  border-radius: 4px;
}
.container_form .error--text .v-input__slot {
  border: 1px solid #ec1b0e;
}
.wrapper_full .container_form .v-text-field__details {
  display: block !important;
  margin-top: 2px;
}
</style>
<style lang="scss" scoped>
.wrapper_contacts {
  background-color: #f8f9fb;
  position: relative;
  padding: 35px 16px;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 35px;
  align-items: center;
  justify-content: center;
  justify-items: center;
  width: 100%;
  text-align: center;
  min-height: 100vh;
  .contactImg {
    width: 100%;
    height: auto;
    max-height: 150px;
    max-width: 500px;
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      max-height: 90px;
    }
  }
  svg {
    width: auto;
    height: 100px;
  }
  .box {
    text-align: left;
    background-color: #ffffff;
    transition: 0.3s;
    border-radius: 8px;
    padding: 70px 100px;
    box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
    max-width: 675px;
    width: 100%;
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      margin: 0 3%;
      width: 97%;
    }
    @media #{map-get($display-breakpoints, 'sm-only')} {
      padding: 70px;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding: 30px 12px;
    }
    .confirm {
      display: grid;
      grid-row-gap: 40px;
      justify-content: center;
      justify-items: center;
      text-align: center;
      font-weight: 500;
      font-size: 24px;
      line-height: 36px;
      color: #2c2c2c;
    }
  }
  hr {
    border-bottom: 1px solid #bedbeb;
    border-top-width: 0px;
  }
  h6 {
    font-weight: 300;
    font-size: 36px;
    line-height: 36px;
    color: #383838;
    margin-bottom: 40px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      font-size: 32px;
      margin-bottom: 20px;
    }
  }
  .v-text-field {
    input {
      padding: 12px 0px 12px 16px !important;
    }
  }
  .v-input__slot {
    margin-bottom: 0px !important;
    padding-left: 16px;
  }
  .how_password {
    cursor: pointer;
    color: #2c2c2c;
    border-bottom: 1px solid #2c2c2c;
    text-decoration: none;
    transition: all 0.3s;
    &:hover {
      color: #277faf;
      border-bottom: 1px solid #277faf;
    }
  }
}
.container_form {
  text-align: left;
  label {
    font-weight: normal;
    font-size: 14px;
    line-height: 26px;
    color: #52525f;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
    margin-bottom: 5px;
  }
}
</style>
